import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  IProtectionDialogContentItemProps,
  ProtectionDialogContentItem,
} from '@/components/ui/TripProtection/ProtectionDialogContentItem';
import { EProtections } from '@/services/types/core/protections';

import { EProtectionLabel, ProtectionLabel } from './ProtectionLabel';

interface IProtectionDialogContentProps {
  category: EProtections;
  serviceIsAdded: boolean;
  inBillSection?: boolean;
}

export const ProtectionDialogContent: React.FC<
  React.PropsWithChildren<IProtectionDialogContentProps>
> = ({ category, serviceIsAdded, inBillSection = false, children }) => {
  const items: IProtectionDialogContentItemProps[] =
    category === EProtections.TRIP_INSURANCE
      ? [
          {
            title: <FormattedMessage defaultMessage="Trip reimbursement" id="le8jQj" />,
          },
          {
            title: <FormattedMessage defaultMessage="Baggage delay coverage" id="4Iqe96" />,
          },
          {
            title: (
              <FormattedMessage defaultMessage="Emergency transport reimbursement" id="qEiG+x" />
            ),
          },
          {
            title: <FormattedMessage defaultMessage="10-day free look period" id="VBB9yX" />,
          },
        ]
      : category === EProtections.DAMAGE_PROTECTION
        ? [
            {
              title: (
                <FormattedMessage defaultMessage="Broken appliances and electronics" id="jX6Lms" />
              ),
            },
            {
              title: (
                <FormattedMessage
                  defaultMessage="Damaged walls, furniture, and doors"
                  id="TVoF4G"
                />
              ),
            },
            { title: <FormattedMessage defaultMessage="Lost keys and rekeying" id="9uFvFV" /> },
            { title: <FormattedMessage defaultMessage="Stained bedding or linens" id="2IlMps" /> },
          ]
        : category === EProtections.WEATHER_PROTECTION
          ? [
              {
                title: (
                  <FormattedMessage
                    defaultMessage="Sensible will monitor the forecast for your trip location."
                    id="57Jo57"
                  />
                ),
              },
              {
                title: (
                  <FormattedMessage
                    defaultMessage="If rain is forecast, you'll be automatically reimbursed. No claims, no hassle."
                    id="iTUsP8"
                  />
                ),
              },
            ]
          : [];

  let label = EProtectionLabel.LISTING_MODAL_DESCRIPTION;
  if (!inBillSection) {
    label = serviceIsAdded
      ? EProtectionLabel.REMOVE_MODAL_DESCRIPTION
      : EProtectionLabel.ADD_MODAL_DESCRIPTION;
  }

  return (
    <div>
      <Text className="text-secondary-base">
        <ProtectionLabel category={category} label={label} />
      </Text>
      <div className={`${inBillSection ? 'mb-4' : 'mb-6'}`}>
        {items.map(({ title, description }, index) => (
          <ProtectionDialogContentItem key={index} title={title} description={description} />
        ))}
      </div>
      {children}
      <Text
        variant={ETextStyleVariant.SmallRegular}
        className="mt-2 text-center text-secondary-base">
        <FormattedMessage defaultMessage="Only available for U.S. residents." id="gUTT6q" />
      </Text>
    </div>
  );
};
